import { render, staticRenderFns } from "./context-menu-item.vue?vue&type=template&id=139b7df9&scoped=true"
import script from "./context-menu-item.vue?vue&type=script&lang=js"
export * from "./context-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b7df9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139b7df9')) {
      api.createRecord('139b7df9', component.options)
    } else {
      api.reload('139b7df9', component.options)
    }
    module.hot.accept("./context-menu-item.vue?vue&type=template&id=139b7df9&scoped=true", function () {
      api.rerender('139b7df9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/context-menu-item.vue"
export default component.exports